import { parse } from "graphql";
const ONBOARDING_MESSAGE = `
        customerFirstName 
        expertPrefUIControl
        viewCustAuth
        tenantChannel
        country
        state
        displayName
        body
        enableAttachment
        viewRespAuth
        groupName
        customerLastNameInitial
        language
        knowledgeBaseIsActive
        respCodeUIControl
        msgClassificationUIControl
        tagUIControl
        dialogueNoteUIControl
        expired
        messageId
        tenantMsgId
        tenantMsgType
        author
        fee
        created
        tenantName
        availableToExperts
        points
        custRespUiExpertPhotos
        releaseState
        custConfirmationUIControl
        custConfirmationState
        custConfirmation
        dialogues {
            origin
            mimeType
            groupName
            created
            tenantName
            dialogueId
            updated
            messageId
            quarantine
            author
            body
            type
            review {
                likes
                agrees
                disagrees
            }
            attachments {
                contentType
                created
                fileName
                size
                url
                valid
            }
            suggestedAnswers {
                body
                mimeType
                created
                updated
                suggestedAnswerId
                dialogueId
                state
                suggestedAnswerScore
                metaData {
                    name
                    value
                }
            }
            custConfirmationUIControl
            custConfirmationState
            userId
            contentModerated {
                action
                reason
            }
            reviewState
        }
        expertAuthors
        inbox {
            claimedAt
            expires
            reported
            reward
            claimed
            reviewed
            escalated
            messageId
            userId
            userName
            claimTimeout
            body
            author
            passed
            responded
            claimTimeoutInc
            groupName
            created
            tenantName
            updated
            new
            type
            totalIncrement
            deleted
            assignedExpertExpiry
            expertCountry
            msgAvailabilityGroup
            msgAvailabilityReleased
            msgAvailableFrom
            deployed
            claimExtendUIControl
        }
        customerData
        msgClassification {
            classificationCode
            classificationCodeDescription
        }
        responseCode
        responseCodeDesc
        tags
        escalateNote
        escalateReason
        escalateReasonDesc
        replyUIControl
        reportNote
        reportReason
        reportReasonDesc
        assignedExpertId
        allowedAttachmentTypes
        custScoreScheme {
            name
            resolvedThreshold
            lowScoreReviewThreshold
            maxScore
            defaultScore
        }
        custResolved
        acceptedDate
        escalatedAt
        primaryResponseDate
        primaryResponseDialogueId
        reportedAt
        primaryResponseAuthor
        action
        lifecycleState
        reviewState
        reviewRequiredVotingExperts
        claimExtendUIControl
        practiceGroup
        reviewScore
        reviewCriteria {
            name
            description
            reviewScheme
            weight
            score
        }
        onboarding {
            modelAnswer
            responseType
        }
        reviewNotes {
            note
            createdBy
            created
        }
    
`;
const CANDIDATE_ONBOARDING_SUMMARY = `
    onboardingOutcomeState
    practiceQuestionsTotal
    reviewCompletedTotal
    completedByExpertTotal
    expertScoreTotal
    maxExpectedScore
    activePracticeQuestions {${ONBOARDING_MESSAGE}}
    nonActivePracticeQuestions {${ONBOARDING_MESSAGE}}
    totalChecks
    totalAssignedPracticeQuestion {
        questionId
        body
        authorEmail
        authorName
        modelAnswer
        responseType
        isActive
        created
        createdBy
        updated
        updatedBy
        categoryId
    }
    completedChecks
    checks {
        id
        value
        name
        requiresInputFrom
        visibleTo
        title
        description
        target
        mandatory
        requiresVerification
        verificationFailedText
        render {
            fieldType
            items
        }
        metaInfo {
            createdBy
            createdAt
        }
        readOnly
        verification {
            valid
            verifiedBy
            verifiedAt
        }
    }

`;
export const GET_ONBOARDING_SUMMARY_FOR_GROUP = parse(`
    query getOnboardingSummaryForGroup($tenantName: String!, $groupName: String!) {
        getOnboardingSummaryForGroup(tenantName: $tenantName, groupName: $groupName) {
            ${CANDIDATE_ONBOARDING_SUMMARY}
        }
    }
`);
export const GET_ONBOARDING_SUMMARY = parse(`
    query getOnboardingSummary {
        getOnboardingSummary {
            tenantName
            groupName
            displayName
            membershipState
            onboardingOutcomeState
            practiceQuestionsTotal
            reviewCompletedTotal
            completedByExpertTotal
            language
            country
            endDate
            startDate
            totalChecks
            completedChecks
            mcqPageEnabled
            latestQuizScore
            brandLearningPageEnabled
            quizAttemptsLeft
            documentVerification
            documentVerificationCompleteChecks
            totalQuestionAssigned
        }
    }
`);
export const CHANGE_ONBOARDING_INVITATION = parse(`
    mutation changeOnboardingInvitationStatus($tenantName: String!, $groupName: String!, $accepted: Boolean!) {
        changeOnboardingInvitationStatus(tenantName: $tenantName, groupName: $groupName, accepted: $accepted) {
            successCount
            failureCount
            result
        }
    }
`);
export const UPDATE_CLIENT_CHECK = parse(`
mutation updateClientCheckValue($id: String!, $tenantName: String!, $groupName: String!, $value: String!) {
    updateClientCheckValue(
        id: $id
        tenantName: $tenantName
        groupName: $groupName
        tenantName: $tenantName
        value: $value
        ) {
            ${CANDIDATE_ONBOARDING_SUMMARY}
        }
    }
    `);
export const UPDATE_QUIZ_STATUS = parse(`
        mutation updateQuizStatus($tenantName: String!, $groupName: String!, $score: Int!) {
            updateQuizStatus(tenantName: $tenantName, groupName: $groupName, score: $score) {
                latestQuizScore
                quizAttemptsLeft
            }
        }
    `);
export const INITIATE_BRAND_LEARNING = parse(`
    mutation initiateBrandLearning($tenantName: String!, $groupName: String!) {
        initiateBrandLearning(tenantName: $tenantName, groupName: $groupName) {
            result
            successCount
            failureCount
        }
    }
`);